export default "__VITE_PUBLIC_ASSET__bf51d50f__"